module.exports = __webpack_public_path__ + "static/media/logos-centro.45f37998.jpg";